<template>
    <Dropdown :expanded="expanded">
        <template slot="toggle">
            <div 
                class="toolbar-button">
                <Icon 
                    :svg="columnSelectorIcon" />
                <Icon
                    :svg="arrowDownIcon" 
                    class="dropdown-icon" />
            </div>
        </template>

        <template slot="list">
            <div class="list">
                <div class="columns-container">
                    <div class="columns">
                        <div
                            v-for="(column, index) in columnsState"
                            :key="index"
                            class="column">
                            <label>
                                <input 
                                    v-model="column.visible"
                                    type="checkbox"> {{ column.label }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div 
                        class="cancel" 
                        @click="hide()">
                        Cancel
                    </div>
                    <div 
                        class="apply"
                        @click="apply()">
                        Apply
                    </div>
                </div>
            </div>
        </template>

    </Dropdown>
</template>

<script>

import Dropdown from './Dropdown';
import Icon from './Icon';

import ColumnSelectorIcon from 'voluum-frontend-icons/column-selector.svg';
import ArrowDownIcon from 'voluum-frontend-icons/arrow-down.svg';

export default {
    name: 'ColumnSelector',

    components: {
        Dropdown,
        Icon
    },

    props: {
        columns: {
            type: Array,
            required: true
        }
    },

    data: function () {
        const columnsState = this.columns.map(column => {
            return {
                key: column.key,
                visible: column.visible,
                label: column.label
            };
        });
        return {
            columnsState: columnsState,
            expanded: { state: false },
            columnSelectorIcon: ColumnSelectorIcon,
            arrowDownIcon: ArrowDownIcon
        };
    },

    methods: {
        hide: function () {
            this.expanded = { state: false };
        },
        
        apply: function () {

            const newColumns = this.columnsState.map((column) => {
                return {
                    key: column.key,
                    visible: column.visible,
                    label: column.label
                };
            });

            this.$store.commit('columnsVisibilityChanged', newColumns);

            this.hide();
        }
    }
};
</script>

<style lang="less" scoped>
    
    @import "../styles/colors.less";
    @import "../styles/globals.less";

    @column-width: 288px;

    .columns {
        display: flex;
        flex-wrap: wrap;
        width: @column-width * 3;
    }

    .list {
        background-color: @color-white;
    }

    .footer, .columns-container {
        padding: @padding;
    }

    .columns-container {
        height: auto;
        max-height: 356px;
        overflow: auto;
    }

    .column {
        width: @column-width;
        
        
        text-align: left;
        display: flex;
        align-items: center;

        label {
            width: 100%;
            height: 100%;
            padding: 6px 8px;
        }
    }

    .column + .column {
        border-top: 1px solid @border-grey;
    }

    .column:hover {
        background-color: @dropdown-option-hover-blue;
    }

    .column:nth-child(3n - 1) {
        border-right: 1px solid @border-grey;
        border-left: 1px solid @border-grey;
    }

    .footer {
        box-shadow: 0 0 10px 0 rgba(0,0,0,.15);
        display: flex;
        justify-content: flex-end;
    }

    label, .cancel, .apply {
        cursor: pointer;
    }

    .cancel, .apply {
        display: inline-flex;
        align-items: center;
        text-align: center;
        justify-content: center;

        border-radius: @border-radius;
        padding: 0 @padding;
        margin-left: @padding;
        width: @padding * 8;

        height: @inline-component-height;
    }

    .cancel {
        background-color: @input-background-grey;
        color: @color-blue;
    }

    .apply {
        background-color: @color-blue;
        color: white;
    }

</style>


// WEBPACK FOOTER //
// src/components/ColumnSelector.vue